<template>
  <div class="page loan-history">
    <navigation>我的账单</navigation>
    <div class="repay-tabs">
      <div class="tab-item" :class="{current: currentTab === 'repayOrder'}" @click="currentTab = 'repayOrder'">还款账单</div>
      <div class="tab-item" :class="{current: currentTab === 'expenseOrder'}" @click="currentTab = 'expenseOrder'">消费账单</div>
    </div>
    <template v-if="currentTab === 'repayOrder'">
      <section v-if="orderList.length === 0" class="no-loan">
        <img src="./images/no_history.png">
        <div class="tips">暂无借款申请，赶快去申请吧</div>
      </section>
      <section class="loan-list" v-else>
        <div class="unit" @click="goRepaymentDetail(value)" v-for="(value, index) of orderList" :key="index">
          <div class="platform">
            <img src="./images/icon_tmd.png" alt="天美贷">
            <span class="name">天美贷</span>
          </div>
          <div class="money-content">{{value.applyAmount | currency}}</div>
          <div class="money-title">借款金额</div>
          <div class="line"></div>
          <div class="time-content">{{ value.creditStartTime | date('YYYY/MM/DD') }}</div>
          <div class="time-title">借款日期</div>
          <div class="content-title" >
            <img :src="formatImage(value)" alt="" >
          </div>
        </div>
      </section>
    </template>
    <template v-if="currentTab === 'expenseOrder'">
      <section v-if="expenseList.length === 0" class="no-loan">
        <img src="./images/no_history.png">
        <div class="tips">暂无消费账单</div>
      </section>
      <section v-else class="expense-list">
        <div v-for="item in expenseList" :key="item.billNo" class="expense-item" @click="handleRouteDetail(item.billNo)">
          <div class="item-title">{{item.rightName}}</div>
          <div class="item-content">
            <div class="item-amount">{{item.schdLoanServFee | currency}}（元）</div>
            <div class="item-time">{{item.lendingDate | date('YYYY/MM/DD')}}</div>
          </div>
          <div class="item-tag">
            <img v-if="item.rightStatus === 'ING'" src="./images/img_jinxingzhong@2x.png">
            <img v-else-if="item.rightStatus === 'S'" src="./images/img_yizhifu@2x.png">
            <img v-else-if="item.rightStatus === 'C'" src="./images/img_yiguanbi@2x.png">
            <img v-else-if="item.rightStatus === 'O'" src="./images/img_yiguanbi.png">
            
          </div>
        </div>
      </section>
    </template>
  </div>
</template>

<script>
import { mapActions, mapMutations } from 'vuex'
import JieQingIcon from './images/icon_jieqing.png'
import YuQiIcon from './images/img_overdue.png'
import JinXingIcon from './images/icon_jinxing.png'
// import { getKey } from '../../assets/utils'
export default {
  name: 'loan-history',
  customReadyNotify: true,
  data () {
    return {
      currentTab: 'repayOrder', // tab名：repayOrder、expenseOrder
      loanStory: [],
      orderList: [],
      expenseList: []
    }
  },
  watch: {
    currentTab (val) {
      this.$report({
        id: 20995,
        args: {
          status: val === 'repayOrder' ? 'loan' : 'buy'
        }
      })
    }
  },
  async created () {
    await Promise.all([
      this.getOrderList(),
      this.getExpenseList()
    ])
    this.$bus.$emit('ready')
    // 第一次进来埋一次订单列表
    this.$report({
      id: 20995,
      args: {
        status: 'loan'
      }
    })
    const { currentTab } = this.$route.query
    if (currentTab) {
      this.currentTab = currentTab
    }
  },

  methods: {
    ...mapActions('order', ['getOrderHisX', 'queryExpenseListX']),
    ...mapMutations('user', ['setUserInfo']),
    // 获取借款历史
    async getOrderList () {
      const response = await this.getOrderHisX()
      if (response.success) {
        this.orderList = response.data.sysOrderLine.map(item => {
          item.orderOutLineInfo = item.orderOutLineInfo.map(subItem => {
            subItem.loanPlatform = item.type
            return subItem
          })
          return item.orderOutLineInfo
        }).reduce((a, b) => {
          return a.concat(b)
        }, [])
        // .sort((a, b) => a.creditStartTime - b.creditStartTime)
        console.log(this.orderList)
      }
    },
    // 获取消费账单
    async getExpenseList () {
      const { success, data } = await this.queryExpenseListX()
      if (success && data) {
        this.expenseList = data.bills || []
      }
    },
            
    // 格式化状态颜色
    formatImage (item) { 
      console.log('formatImage')
      if (item.hasOverdue) {
        return YuQiIcon
      } else if (item.hasCompleted) {
        return JieQingIcon
      } else {
        return JinXingIcon
      }
    },
    // 路由跳转
    goRepaymentDetail (item) {
      let params = {
        orderId: item.orderId, // 订单号（颜值贷）
        loanPlatform: item.loanPlatform,
        productCd: item.productCd,
        from: item.hasCompleted
      }
      this.$router.push({ path: '/repayment/detail', query: params })
    },
    // 跳转消费账单详情页面
    handleRouteDetail (billNo) {
      this.$router.push({
        path: '/repayment/detail-expense',
        query: {
          repayBillNo: billNo
        }
      })
    }
  }
}
</script>

<style scoped lang="less">
@import "../../assets/less/mixin.less";

    .loan-history {
        height: 100%;
        position: relative;
        background-color: #FAFAFA;
        overflow: auto;

        .title {
            font-size: 82px;
            font-family: PingFangSC-Light;
            font-weight: 300;
            color: #333333;
            line-height: 1;
            margin-top: 21px;
            padding-left: 50px;
        }
        .repay-tabs{
          background-color: #fff;
          display: flex;
          justify-content: space-around;
          padding: 0 50px;
          .tab-item{
            font-size: 34px;
            color: #BBBBBB;
            position: relative;
            height: 98px;
            line-height: 98px;
            font-weight: bold;
            &.current{
              color: #333333;
              &::after{
                content: "";
                display: block;
                position: absolute;
                width: 42px;
                height: 4px;
                background-color: #333333;
                bottom: -2px;
                left: 50%;
                transform: translateX(-50%);
              }
            }
          }
        }

        .no-loan {
            width: 100%;

            img {
                width: 408px;
                height: 250pxm;
                margin-top: 196px;
                margin-left: 173px;
            }

            .tips {
                font-size: 26px;
                font-family: PingFangSC-Regular;
                color: #999999;
                line-height: 1;
                text-align: center;
                margin-top: 26px;
            }
        }

        .loan-list {
            margin-top: 63px;

            .unit {
                background-color: #ffffff;
                position: relative;
                height: 300px;
                width: 670px;
                margin-bottom: 20px;
                left: 40px;
                border-radius: 20px;
                font-size: 32px;
                .platform {
                    position: relative;
                    img {
                        width: 48px;
                        height: 48px;
                        margin-top: 42px;
                        margin-left: 30px;
                    }
                    .name {
                        position: absolute;
                        margin-left: 15px;
                        top: 46px;
                        font-size: 28px;
                        font-family: PingFangSC-Regular, PingFang SC;
                        font-weight: 400;
                        color: #666666;
                        line-height: 40px;
                    }
                }

                .money-title {
                    position: absolute;
                    top: 205px;
                    left: 108px;
                    font-size: 28px;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #666666;
                    line-height: 40px;
                }

                .money-content {
                    position: absolute;
                    top: 157px;
                    left: 108px;
                    font-size: 34px;
                    font-family: DIN-Medium, DIN;
                    font-weight: 500;
                    color: #333333;
                    line-height: 41px;
                }

                .line {
                    position: absolute;
                    left: 335px;
                    top: 174px;
                    width: 1px;
                    height: 40px;
                    background: #CCCCCC;
                }

                .time-title {
                    position: absolute;
                    top: 205px;
                    left: 453px;
                    font-size: 28px;
                    font-family: PingFangSC-Regular;
                    color: #666666;
                    line-height: 1;
                }

                .time-content {
                    position: absolute;
                    top: 157px;
                    left: 440px;
                    font-family: DIN-Medium, DIN;
                    font-weight: 500;
                    color: #333333;
                    line-height: 41px;
                }

                .content-title {
                    position: absolute;
                    top: 0px;
                    right: 0px;
                    img {
                        width: 106px;
                        height: 106px;
                    }
                }
            }
        }
        .expense-list{
          padding: 30px 40px;
          .expense-item{
            background-color: #fff;
            border-radius: 20px;
            position: relative;
            padding: 45px 40px;
            & + .expense-item{
              margin-top: 30px;
            }
            .item-title{
              font-size: 28px;
              color: #666666;
            }
            .item-content{
              display: flex;
              justify-content: space-between;
              align-items: center;
              margin-top: 28px;
              .item-amount{
                font-size: 44px;
                color: #333333;
                font-weight: bold;
                font-family: DIN-Medium, DIN;
              }
              .item-time{
                font-size: 28px;
                color: #666666;
              }
            }
            .item-tag{
              position: absolute;
              font-size: 0;
              top: 0;
              right: 0;
              img{
                width: 106px;
                height: 106px;
              }
            }
          }
        }
    }
</style>
